<template>
  <div class="container" ref="containerRef">
    <div class="top">
      <i18n-t class="trophy_intro font40px" keypath="trophy.text" tag="div" scope="global">
        <template #trophy_num>
          <span class="font64px highlight">{{ props.data.totalTrophy }}</span>
        </template>
      </i18n-t>
    </div>
    <van-row class="achievement"  justify="center" align="center" v-for="(item, keys) in detail" :key="keys">
      <van-col span="10">
        <img class="trophy" :src="item.image" />
      </van-col>
      <van-col span="14">
        <div v-if="te(item.title)" class="title">{{ $t(item.title) }}</div>
        <i18n-t v-else class="title" keypath="trophy.other_title" tag="div" scope="global">
          <template #mtt_name>
            <span class="title">{{ item.name }}</span>
          </template>
        </i18n-t>
        <div v-if="te(item.desc)" data-aos="fade-up" class="desc">{{ $t(item.desc) }}</div>
        <div class="data">
          <div class="progress">
            <div class="progress-value" :style="{ animation: `load${keys} ${ noEffect ? 0 : 3}s normal forwards`}"></div>
          </div>
          <span class="current">{{ item.current }}</span> <span class="total">/{{ item.total }}</span>
        </div>
      </van-col>
    </van-row>
    <div class="font40px endText">{{ $t('trophy.endText')}}</div>
  </div>
</template>
<script setup>
import { te } from "@/locales";
import { defineProps, ref, onMounted, onUnmounted } from "vue";
  const props = defineProps({
    data: {
        type: Object,
        default : () => {}
    }
  })
  const containerRef = ref(null)
  const urlParams = new URLSearchParams(window.location.search)
  const noEffect = !!urlParams.get("no_effect")
  const detail = ref([])
  function mappingTrophy () {
    const value = props.data.trophyList
    value.forEach((item, key) => {
      const obj = {
        current: item.current,
        total: item.total,
        name: item.name,
        image: require(`@img/trophy/${item.name}_${item.type}.png`),
        title: `trophy.${item.name}_title`,
        desc: `trophy.${item.name}_desc`
      }
      detail.value.push(obj)
    })
  }
  onMounted(() => {
    mappingTrophy()
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
              detail.value.forEach((item, index) => {
                createAnimation(index, item.current, item.total)
              })
            }
        })
    })
    if (containerRef.value) {
        observer.observe(containerRef.value);
    }
    onUnmounted(() => {
        if (containerRef.value) {
        observer.unobserve(containerRef.value)
        }
    })
  })
  const createAnimation = (index, current, total) => {
    const styleEl = document.createElement('style')
    document.head.appendChild(styleEl)
    const percentage = (current/total)*100
    const keyframes = `
        @keyframes load${index} {
            0% { width: 0; }
            100% { width: ${percentage}%; }
        }
    `
    styleEl.innerHTML = keyframes
  }
</script>
<style lang="scss" scoped>
.container {
    position:relative;
    .top {
      text-align: left;
      margin: 0 10%;
    }
    .trophy_intro {
      color: #fff;
      .highlight {
        color: #fff153;
      }
    }
    .achievement {
      display: flex;
      flex-wrap: nowrap;
      text-align: left;
      background-image: url('~@img/keyVisual/frame_15.png');
      background-position: center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 90%;
      margin: 5%;
      padding: 8% 0;
      height: 231px;
      @media (max-width: $containerWidth) {
        height: pxToVw(231px);
      }
    }
    .data {
      display: flex;
      align-items: center;
      span {
        font-size: 20px;
        color: #fff;
        @media (max-width: $containerWidth) {
          font-size: pxToVw(22px);
        }
      }
      .current {
        margin-left: 5%;
        color: #fff153
      }
      .total {
        color: #fff;
      }
    }
    .progress {
      display: inline-block;
      background: #1b1b25;
      justify-content: flex-start;
      border-radius: 100px;
      align-items: center;
      position: relative;
      padding: 0 px;
      display: flex;
      height: 13px;
      width: 70%;
    }

    .progress-value {
        animation: load 0s normal forwards;
        box-shadow: 0 10px 40px -10px #fff153;
        border-radius: 100px;
        background: #fff153;
        height: 8px;
        width: 0;
    }

    .title {
        color: #fff;
        font-size: 50px;
        margin: 15px 0;
        @media (max-width: $containerWidth) {
            font-size: pxToVw(40px);
        }
    }
    .desc {
        color: #fff;
        font-size: 30px;
        margin: 15px 0;
        @media (max-width: $containerWidth) {
            font-size: pxToVw(30px);
        }
    }


    .endText {
      color: #fff;
      margin: 0 5%;
    }
}
</style>